(function () {
  if (window.__bbBaInit) return;
  window.__bbBaInit = true;

  function init(root) {
    var stage = root.querySelector('[data-ba-stage]');
    var after = root.querySelector('[data-ba-after]');
    var handle = root.querySelector('[data-ba-handle]');
    if (!stage || !after || !handle) return;
    var pos = 50, dragging = false;

    function set(p) {
      pos = Math.max(0, Math.min(100, p));
      after.style.clipPath = 'inset(0 0 0 ' + pos + '%)';
      handle.style.left = pos + '%';
      handle.setAttribute('aria-valuenow', Math.round(pos));
    }
    function fromEvent(e) {
      var r = stage.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - r.left;
      set((x / r.width) * 100);
    }
    function down(e) { dragging = true; fromEvent(e); e.preventDefault(); }
    function move(e) { if (dragging) fromEvent(e); }
    function up() { dragging = false; }

    handle.addEventListener('mousedown', down);
    stage.addEventListener('mousedown', down);
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
    handle.addEventListener('touchstart', down, { passive: false });
    stage.addEventListener('touchstart', down, { passive: false });
    window.addEventListener('touchmove', move, { passive: false });
    window.addEventListener('touchend', up);
    handle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { set(pos - 4); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { set(pos + 4); e.preventDefault(); }
    });
    set(50);
  }

  function boot() { document.querySelectorAll('[data-bb-ba]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
